import { ActionIcon } from "@mantine/core";
import { ButtonBurguer } from "./ButtonBurguer";

export const ButtonBurguerThumb = ({ opened, onClick, text = "" }) => {
	function handleClick(ev) {
		ev.stopPropagation();
		onClick();
	}

	return (
		<ActionIcon variant="light" color="gray" component="div">
			<ButtonBurguer opened={opened} onClick={handleClick} text={text} />
		</ActionIcon>
	);
};
